export const PERFECT_STORE_TARGET_TYPES = {
  FirstPositionTarget: 'First Position Target',
  RacksAndCoolersTarget: 'Racks and Coolers Target',
  StoreExecutionTarget: 'Store Execution Target',
  MustHaveProductsTarget: 'Must Have Products',
  StoreExecutionTargetPepIris: 'Store Execution Target - PepIris'
};

export const PERFECT_STORE_TARGET_TYPE_VALUES = {
  FIRST_POSITION: 'First Position Target',
  RACKS_AND_COOLERS: 'Racks and Coolers Target',
  STORE_EXECUTION: 'Store Execution Target',
  MUST_HAVE_PRODUCTS: 'Must Have Products',
  STORE_EXECUTION_PEPIRIS: 'Store Execution Target - PepIris'
};

// Legacy API/code values kept for mid-migration compatibility (in-memory / older payloads).
export const LEGACY_PERFECT_STORE_TARGET_TYPE_VALUES = {
  FIRST_POSITION: 'FIRST_POSITION',
  RACKS_AND_COOLERS: 'RACKS_AND_COOLERS',
  STORE_EXECUTION: 'STORE_EXECUTION',
  MUST_HAVE_PRODUCTS: 'MUST_HAVE_PRODUCTS',
  STORE_EXECUTION_PEPIRIS: 'STORE_EXECUTION_PEPIRIS'
};

export const PERFECT_STORE_TARGET_TYPE_OPTIONS = [
  {
    id: PERFECT_STORE_TARGET_TYPE_VALUES.FIRST_POSITION,
    displayText: PERFECT_STORE_TARGET_TYPES.FirstPositionTarget,
    value: PERFECT_STORE_TARGET_TYPE_VALUES.FIRST_POSITION
  },
  {
    id: PERFECT_STORE_TARGET_TYPE_VALUES.RACKS_AND_COOLERS,
    displayText: PERFECT_STORE_TARGET_TYPES.RacksAndCoolersTarget,
    value: PERFECT_STORE_TARGET_TYPE_VALUES.RACKS_AND_COOLERS
  },
  {
    id: PERFECT_STORE_TARGET_TYPE_VALUES.STORE_EXECUTION,
    displayText: PERFECT_STORE_TARGET_TYPES.StoreExecutionTarget,
    value: PERFECT_STORE_TARGET_TYPE_VALUES.STORE_EXECUTION
  },
  {
    id: PERFECT_STORE_TARGET_TYPE_VALUES.MUST_HAVE_PRODUCTS,
    displayText: PERFECT_STORE_TARGET_TYPES.MustHaveProductsTarget,
    value: PERFECT_STORE_TARGET_TYPE_VALUES.MUST_HAVE_PRODUCTS
  },
  {
    id: PERFECT_STORE_TARGET_TYPE_VALUES.STORE_EXECUTION_PEPIRIS,
    displayText: PERFECT_STORE_TARGET_TYPES.StoreExecutionTargetPepIris,
    value: PERFECT_STORE_TARGET_TYPE_VALUES.STORE_EXECUTION_PEPIRIS
  }
];

export const isFirstPositionTarget = (targetType) =>
  targetType === PERFECT_STORE_TARGET_TYPE_VALUES.FIRST_POSITION ||
  targetType === LEGACY_PERFECT_STORE_TARGET_TYPE_VALUES.FIRST_POSITION;

export const FIRST_POSITION_CSV_RULES = {
  type: 'text/csv',
  size: 10 * 1024 * 1024,
  enforceSize: true,
  columns: [
    {
      name: 'Store Id',
      required: true,
      type: 'alphanumeric',
      minChar: 1,
      maxChar: 255
    },
    {
      name: 'Visit Number',
      required: true,
      type: 'number'
    },
    {
      name: 'Points',
      required: true,
      type: 'number'
    }
  ],
  requiredHeaders: ['Store Id', 'Visit Number', 'Points']
};

export const FIRST_POSITION_TEMPLATE_CSV = [
  FIRST_POSITION_CSV_RULES.columns.map(({name}) => name).join(',')
].join('\n');

// Target types the Display step currently supports; add more here to enable it for other types.
export const PERFECT_STORE_DISPLAY_STEP_TARGET_TYPES = [
  PERFECT_STORE_TARGET_TYPE_VALUES.FIRST_POSITION
];

export const isDisplayStepApplicable = (targetType) =>
  PERFECT_STORE_DISPLAY_STEP_TARGET_TYPES.includes(targetType) ||
  targetType === LEGACY_PERFECT_STORE_TARGET_TYPE_VALUES.FIRST_POSITION;

export const PERFECT_STORE_IMAGE_TYPES = [
  'image/png',
  'image/jpeg',
  'image/webp'
];

export const PERFECT_STORE_IMAGE_DIMENSIONS = {width: 800, height: 450};

// Ratio derived from the required 800x450 dimensions (16:9)
export const PERFECT_STORE_IMAGE_ASPECT_RATIO =
  PERFECT_STORE_IMAGE_DIMENSIONS.width / PERFECT_STORE_IMAGE_DIMENSIONS.height;

export const PERFECT_STORE_IMAGE_ASPECT_RATIO_LABEL = '16:9';

export const PERFECT_STORE_IMAGE_MAX_SIZE_BYTES = 70 * 1024;

export const MAX_RACK_DISPLAYS = 3;

export const RACK_TEXT_MAX_LENGTH = 100;

export const BANNER_TITLE_MAX_LENGTH = 100;

export const BANNER_DESCRIPTION_MAX_LENGTH = 500;

export const MOCK_PERFECT_STORE_LIST = [
  {
    id: 'ps-1',
    name: 'First Position Q1 Target',
    targetType: PERFECT_STORE_TARGET_TYPE_VALUES.FIRST_POSITION,
    status: 'Draft'
  }
];
